module.exports = __webpack_public_path__ + "media/images/resources/thumb_down-df17b4a2ed503a582b4842104846b6ef.svg";